export const customListCircles = /* GraphQL */ `
  query CustomListCircles(
    $filter: ModelCircleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCircles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        imageUrl
        privacy
        interest
        organizationGroup
        admins
        members {
          items {
            id
            organizationGroup
            role
            status
            requestStatus
            circleUserCircleId
            circleUserUserId
            user {
              id
              email
              firstName
              lastName
              avatarUrl
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            inviterNotes
            requestNotes
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            circleUserInviterId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        creator
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const customListEvents = /* GraphQL */ `
  query CustomListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationGroup
        name
        description
        imageUrl
        startTime
        endTime
        circleEventId
        isHidden
        attendee {
          items {
            id
            organizationGroup
            eventAttendeeId
            eventAttendeeUserId
            status
            requestStatus
            inviterNotes
            requestNotes
            user {
              id
              email
              firstName
              lastName
              avatarUrl
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            eventAttendeeInviterId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        interests
        privacy
        admins
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const customGetCircle = /* GraphQL */ `
  query CustomGetCircle($id: ID!, $eventFilter: ModelEventFilterInput) {
    getCircle(id: $id) {
      id
      name
      description
      bannerImageUrl
      imageUrl
      privacy
      isManagedByHR
      event(filter: $eventFilter) {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          attendee {
            nextToken
            startedAt
          }
          interests
          isHidden
          privacy
          admins
          createdAt
          updatedAt
          timezone
          _version
          _deleted
          _lastChangedAt
          owner
        }
        nextToken
        startedAt
      }
      interest
      organizationGroup
      admins
      members(filter: {_deleted: {ne: true}}) {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          user {
            id
            cognitoID
            email
            organizationGroup
            firstName
            lastName
            username
            avatarUrl
            bannerImageUrl
            bio
            jobTitle
            type
            lookingForType
            isClosedForAcceptingMentee
            joinedAt
            phone
            points
            lifetimePoints
            dateOfBirth
            isOnboarded
            minimumIntroducers
            averageRating
            avgMentorRating
            avgMenteeRating
            avgAllyRating
            interest
            expertises
            awards
            titleRank
            ethnicity
            sexuality
            extrovertOrIntrovert
            sensingOrIntuition
            thinkingOrFeeling
            judgingOrPerceiving
            personalityType
            religion
            class
            relationshipStatus
            childhoodZip
            dogOwner
            catOwner
            moonSign
            sunSign
            morningVsNightPerson
            hasSiblings
            birthOrder
            heroes
            sages
            celebsLoveToMeet
            personalityTest
            eatOutVsEatIn
            almaMater
            gender
            race
            vegan
            taxBracket
            nativeBorn
            currentZip
            artist
            musicalInstrument
            generation
            companyClub
            totalSiblings
            vegetarian
            birthCountry
            birthCity
            introVsExtro
            selectedFavorites
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            userFocusedSkillTrackId
            userDepartmentId
          }
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      creator
    }
  }
`;

export const customGetListContext = /* GraphQL */ `query CustomGetListContext($id: ID, $context: [PostContext]) {
  getListContext(id: $id, context: $context) {
    events {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
          user {
            id
            firstName
            lastName
            avatarUrl
          }
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    circles {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt              
              user {
                id
                firstName
                lastName
                avatarUrl
              }
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    users {
      id
      cognitoID
      email
      organizationGroup
      firstName
      lastName
      username
      avatarUrl
      bannerImageUrl
      bio
      jobTitle
      type
      lookingForType
      isClosedForAcceptingMentee
      joinedAt
      lastLoginAt
      deletedAt
      deletedBy
      phone
      points
      lifetimePoints
      dateOfBirth
      isOnboarded
      disabledQuickQuestion
      finishedUserGuideContext
      focusedSkillTrack {
        id
        organizationGroup
        departmentId
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        tag {
          id
          organizationGroup
          name
          description
          type
          category
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        skillTrackTagId
        name
        color
        skills {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      minimumIntroducers
      givenRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      receivedRatings {
        items {
          id
          userFromId
          userFromType
          userToId
          userToType
          organizationGroup
          ratingValue
          comment
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      averageRating
      avgMentorRating
      avgMenteeRating
      avgAllyRating
      userHomepageConfig
      socialMedia {
        linkedIn
        __typename
      }
      targetGoals {
        circle
        event
        connection
        __typename
      }
      interest
      expertises
      department {
        id
        name
        description
        organizationGroup
        skillTracks {
          nextToken
          startedAt
          __typename
        }
        levels {
          nextToken
          startedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      awards
      titleRank
      sensitiveQuestionConsent
      isAskedTwiceAlready
      skippedSensitiveQuestion {
        dateOfBirth
        sexuality
        religion
        class
        relationshipStatus
        category
        taxBracket
        nativeBorn
        birthCity
        moonSign
        sunSign
        generation
        favePoliticalParty
        __typename
      }
      ethnicity
      sexuality
      extrovertOrIntrovert
      sensingOrIntuition
      thinkingOrFeeling
      judgingOrPerceiving
      personalityType
      religion
      class
      relationshipStatus
      childhoodZip
      dogOwner
      catOwner
      moonSign
      sunSign
      morningVsNightPerson
      hasSiblings
      birthOrder
      heroes
      sages
      celebsLoveToMeet
      personalityTest
      eatOutVsEatIn
      almaMater
      gender
      race
      vegan
      taxBracket
      nativeBorn
      currentZip
      artist
      musicalInstrument
      generation
      companyClub
      favorites {
        faveMusicGenre
        faveSinger
        faveMuseum
        faveSportTeam
        faveSport
        faveLanguage
        faveTVShow
        faveBoardGame
        faveVideoGame
        faveBook
        faveTheatreShow
        faveVacation
        faveNewsSource
        faveCity
        faveRestaurant
        faveBar
        faveNightClub
        favePoliticalParty
        faveCharities
        faveDrink
        __typename
      }
      workBehaviours {
        collaboration
        motivation
        pressure
        workLifeBalance
        communication
        openOfficeEnvirontment
        contributorOrManager
        __typename
      }
      totalSiblings
      vegetarian
      birthCountry
      birthCity
      introVsExtro
      selectedFavorites
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userFocusedSkillTrackId
      userDepartmentId
      __typename
    }
    userPosts {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isHighlight
      audienceType
      audienceID
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    recommendedCircles {
      id
      name
      description
      imageUrl
      privacy
      event {
        items {
          id
          organizationGroup
          name
          description
          imageUrl
          startTime
          endTime
          circleEventId
          interests
          privacy
          admins
          timezone
          location
          createdAt
          isManagedByHR
          owner
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      interest
      organizationGroup
      admins
      members {
        items {
          id
          organizationGroup
          role
          status
          requestStatus
          circleUserCircleId
          circleUserUserId
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          circleUserInviterId
          __typename
          user {
            id
            firstName
            lastName
            avatarUrl
          }
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      isManagedByHR
      creator
      CGPercent
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    recommendedEvents {
      id
      organizationGroup
      name
      description
      imageUrl
      startTime
      endTime
      CGPercent
      circleEventId
      circle {
        id
        name
        description
        imageUrl
        privacy
        event {
          nextToken
          startedAt
          __typename
        }
        interest
        organizationGroup
        admins
        members {
          nextToken
          startedAt
          __typename
        }
        createdAt
        isManagedByHR
        creator
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      attendee {
        items {
          id
          organizationGroup
          eventAttendeeId
          eventAttendeeUserId
          status
          requestStatus
          inviterNotes
          isInviterHR
          requestNotes
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          eventAttendeeInviterId
          __typename
          user {
            id
            firstName
            lastName
            avatarUrl
          }
        }
        nextToken
        startedAt
        __typename
      }
      interests
      privacy
      admins
      timezone
      location
      createdAt
      isManagedByHR
      owner
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    teaPosts {
      id
      organizationGroup
      author {
        id
        cognitoID
        email
        organizationGroup
        firstName
        lastName
        username
        avatarUrl
        bannerImageUrl
        bio
        jobTitle
        type
        lookingForType
        isClosedForAcceptingMentee
        joinedAt
        lastLoginAt
        deletedAt
        deletedBy
        phone
        points
        lifetimePoints
        dateOfBirth
        isOnboarded
        disabledQuickQuestion
        finishedUserGuideContext
        focusedSkillTrack {
          id
          organizationGroup
          departmentId
          skillTrackTagId
          name
          color
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        minimumIntroducers
        givenRatings {
          nextToken
          startedAt
          __typename
        }
        receivedRatings {
          nextToken
          startedAt
          __typename
        }
        averageRating
        avgMentorRating
        avgMenteeRating
        avgAllyRating
        userHomepageConfig
        socialMedia {
          linkedIn
          __typename
        }
        targetGoals {
          circle
          event
          connection
          __typename
        }
        interest
        expertises
        department {
          id
          name
          description
          organizationGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        awards
        titleRank
        sensitiveQuestionConsent
        isAskedTwiceAlready
        skippedSensitiveQuestion {
          dateOfBirth
          sexuality
          religion
          class
          relationshipStatus
          category
          taxBracket
          nativeBorn
          birthCity
          moonSign
          sunSign
          generation
          favePoliticalParty
          __typename
        }
        ethnicity
        sexuality
        extrovertOrIntrovert
        sensingOrIntuition
        thinkingOrFeeling
        judgingOrPerceiving
        personalityType
        religion
        class
        relationshipStatus
        childhoodZip
        dogOwner
        catOwner
        moonSign
        sunSign
        morningVsNightPerson
        hasSiblings
        birthOrder
        heroes
        sages
        celebsLoveToMeet
        personalityTest
        eatOutVsEatIn
        almaMater
        gender
        race
        vegan
        taxBracket
        nativeBorn
        currentZip
        artist
        musicalInstrument
        generation
        companyClub
        favorites {
          faveMusicGenre
          faveSinger
          faveMuseum
          faveSportTeam
          faveSport
          faveLanguage
          faveTVShow
          faveBoardGame
          faveVideoGame
          faveBook
          faveTheatreShow
          faveVacation
          faveNewsSource
          faveCity
          faveRestaurant
          faveBar
          faveNightClub
          favePoliticalParty
          faveCharities
          faveDrink
          __typename
        }
        workBehaviours {
          collaboration
          motivation
          pressure
          workLifeBalance
          communication
          openOfficeEnvirontment
          contributorOrManager
          __typename
        }
        totalSiblings
        vegetarian
        birthCountry
        birthCity
        introVsExtro
        selectedFavorites
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        userFocusedSkillTrackId
        userDepartmentId
        __typename
      }
      postAuthorId
      contextType
      contextName
      contextPrivacy
      category
      contextId
      content
      likeUsers
      attachments
      createdAt
      isAuthorHR
      isHighlight
      audienceType
      audienceID
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
`;